// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact_Contact__3d-kp","Form":"Contact_Form__1qc8y"};